<div [ngClass]="{ 'popup-container': isCellEditorPopup }">
  <app-date-field
    #fieldComponent
    [form-control]="formControl"
    [field]="cellParams.field"
    [datePickerPanelClass]="datePickerPanelClass"
  ></app-date-field>
</div>
